export default __webpack_public_path__ + "static/media/endingsoon.0c7ee42f.svg";